import { api } from './api';

/** Brands an account holds and may hold (GET /accounts/me → brands). */
export interface BrandAllowance {
  /** effectivePlan() of the account: STARTER, CLASSIC, PRO or AGENCY. */
  plan: string;
  used: number;
  /** included + paid Agency extras. */
  limit: number;
  included: number;
  extraBrands: number;
  /** Agency: brands past the limit can be bought one at a time. */
  canBuyExtra: boolean;
}

/**
 * GET /api/v1/accounts/me (ADR-006): the account the signed-in person OWNS.
 * Null for someone who owns none (an invited member only). A brand created by
 * this person goes into this account, whichever brand is current.
 */
export interface AccountSummary {
  id: string;
  ownerUserId: string;
  /** effectivePlan() of the account: STARTER, CLASSIC (grandfathered), PRO or AGENCY. */
  plan: string;
  /**
   * When a paid plan that will not renew falls back to Starter; null when it
   * renews or the account is on Starter (ADR-007).
   */
  planEndsAt: string | null;
  subscription: {
    plan: string;
    status: string;
    currentPeriodEnd: string | null;
    extraBrands: number;
    pendingPlan: string | null;
    currency: string | null;
    billingInterval: string | null;
    provider: string;
  } | null;
  brands: BrandAllowance;
}

export const accountService = {
  async getMine(): Promise<AccountSummary | null> {
    const res = await api.get<AccountSummary | null>('/accounts/me');
    return res.data ?? null;
  },
};
